<template>
    <div class="page-cont">

        <div class="infoCheck person-info">
            <el-row class="top-row">
                <el-col :span="4">
                    <h2>
                        被保险人信息资料
                        <em>*</em>
                    </h2>
                </el-col>
                <el-col :span="5">
                    <label>开始时间<em>*</em></label>
                    <el-date-picker v-model="starttime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                        placeholder="保险开始日期"></el-date-picker>
                </el-col>
                <el-col :span="4">
                    <label>企业<em>*</em></label>
                    <el-select placeholder="请选择" v-model="companyid" @change="setCompanyName">
                        <el-option v-for="(item, index) in TravelCompanyList" :key="index" :value="item.TravelCompany_ID"
                            :label="item.TravelCompany_Name"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <label>合同<em>*</em></label>
                    <el-select placeholder="请选择" v-model="insuranceid">
                        <el-option v-for="(item, index) in ProductList" :key="index" :value="item.Insurance_ID"
                            :label="item.Insurance_Destination"></el-option>
                    </el-select>
                </el-col>
                <el-col style="margin: 16px 0;" :span="8" class="insurance-btn-wrp" v-if="tabName == 'withTxt'">
                    <!-- <el-button type="default" plain @click="insuraceModel">下载被保险人Excel模板</el-button> -->
                    <!-- <el-button type="default" plain round @click="addMultiPerson">导入被保险人</el-button> -->
                    <el-button type="default" plain round @click="addPerson">增加被保险人</el-button>
                    <el-button type="default" plain round @click="deleteAll">删除所有</el-button>
                    <el-button type="default" plain round @click="deleteCheck">删除选中</el-button>
                    <!-- <el-button type="primary" plain round @click="confirmPerson">校验</el-button> -->
                    <el-button type="primary" plain round @click="reviewBD('withTxt')">智能识别</el-button>
                    <el-button type="primary" plain round @click="sendFormData">提交</el-button>

                </el-col>
                <el-col style="margin: 16px 0;" :span="6" class="insurance-btn-wrp" v-else>
                    <!-- <el-button type="default" plain @click="insuraceModel(1)">下载被保险人Excel模板</el-button> -->
                    <!-- <el-button type="default" plain round @click="addMultiPerson">导入被保险人</el-button> -->
                    <el-button type="default" plain round @click="addOPerson">增加被保险人</el-button>
                    <el-button type="default" plain round @click="deleteAll">删除所有</el-button>
                    <el-button type="default" plain round @click="deleteCheck">删除选中</el-button>
                    <el-button type="primary" plain round @click="reviewBD('withPass')">智能识别</el-button>
                </el-col>
            </el-row>
            <div class="person-list-wrp">
                <el-tabs v-model="tabName" @tab-click="switchTab" type="card">
                    <el-tab-pane label="添加证件" name="withTxt">
                        <el-row :gutter="6" :class="{ 'err': errArr.includes(item.InsurancePerson_CertNo) }"
                            v-for="(item, index) in visitPersonArr" :key="'visit' + index">
                            <el-col :span="3">
                                <label>被保险人{{ index + 1 }} &nbsp; 姓名*</label>
                                <el-input type="text" v-model="item.InsurancePerson_Name"
                                    placeholder="输入被保险人姓名"></el-input>
                            </el-col>
                            <el-col :span="5">
                                <label> 证件*</label>
                                <el-input type="text" v-model="item.InsurancePerson_CertNo"
                                    placeholder="输入被保险人身份证件号"></el-input>
                            </el-col>
                            <el-col :span="3">
                                <label> 属组*</label>
                                <el-select placeholder="请选择" v-model="item.InsurancePerson_Policy">
                                    <el-option v-for="(item, index) in szList" :key="index" :value="item.Policy_ID"
                                        :label="item.Policy_Name"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="3">
                                <label> 雇主</label>
                                <el-input type="text" v-model="item.InsurancePerson_EmployerName"
                                    placeholder="输入雇主姓名"></el-input>
                            </el-col>
                            <el-col :span="4">
                                <label> 家庭住址</label>
                                <el-input type="text" v-model="item.InsurancePerson_EmployerAddress"
                                    placeholder="输入雇主家庭住址"></el-input>
                            </el-col>
                            <el-col :span="3">
                                <label> 订单类型</label>
                                <el-select placeholder="请选择" v-model="item.InsurancePerson_Relate">
                                    <el-option v-for="(item, index) in orderTypeList" :key="index" :value="item"
                                        :label="item"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="1" class="check-box-wrp">
                                <el-checkbox v-model="item.check" size="medium"
                                    @change="checkboxChange($event, index)"></el-checkbox>
                            </el-col>
                            <el-col :span="2" class="btn-delt" style="text-align:right">
                                <el-popconfirm confirm-button-text="好的" cancel-button-text="再考虑" icon="el-icon-info"
                                    icon-color="red" title="确定要删除吗？" @confirm="sendDelete(index, 0)">
                                    <el-button type="danger" plain round slot="reference">删除</el-button>
                                </el-popconfirm>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                    <!-- <el-tab-pane label="添加护照" name="withPass">
                        <el-row :gutter="16" v-for="(item, index) in outPersonArr" :key="'out' + index">


                            <el-col :span="6">
                                <label>被保险人{{ index + 1 }} 姓名</label>
                                <el-input type="text" v-model="item.InsurancePerson_Name"
                                    placeholder="输入被保险人姓名"></el-input>
                            </el-col>
                            <el-col :span="6">
                                <label>被保险人{{ index + 1 }} 证件</label>
                                <el-input type="text" v-model="item.InsurancePerson_CertNo"
                                    placeholder="输入被保险人身份证件号"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <label>被保险人{{ index + 1 }} 属组</label>
                                <el-select placeholder="请选择" v-model="item.InsurancePerson_Policy">
                                    <el-option v-for="(item, index) in szList" :key="index" :value="item.Policy_ID"
                                        :label="item.Policy_Name"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="2" class="check-box-wrp">
                                <el-checkbox v-model="item.check" size="medium"
                                    @change="checkboxChange($event, index)"></el-checkbox>
                            </el-col>
                            <el-col :span="3" class="btn-delt" style="text-align:right">
                                <el-popconfirm confirm-button-text="好的" cancel-button-text="再考虑" icon="el-icon-info"
                                    icon-color="red" title="确定要删除吗？" @confirm="sendDelete(index, 1)">
                                    <el-button type="danger" plain round slot="reference">删除</el-button>
                                </el-popconfirm>
                            </el-col>
                        </el-row>
                    </el-tab-pane> -->
                </el-tabs>
            </div>
        </div>

        <!-- <el-dialog title="提交确认" :visible.sync="beforeSend" width="36%">
            <p>投保期限：{{ starttime + ' ' + logotime }} 至 {{ starttime + ' 23:59:59' }}</p>
            <p>天数：{{ day }} 天</p>
            <p>人数：{{ personCount }} 人</p>
            <p>总价：{{ Policy_IsEvery == 1 ? (Policy_Money * day * personCount).toFixed(2) : (Policy_Money *
                personCount).toFixed(2) }} 元</p>
            <span slot="footer">
                <el-button type="primary" @click="sendFormData(true)">确认提交</el-button>
                <el-button @click="beforeSend = false">取消</el-button>
            </span>
        </el-dialog> -->
        <el-dialog title="智能识别" :visible.sync="reviewSee">
            <div style="margin-bottom: 12px;">
                <el-select placeholder="请选择属组" v-model="szID">
                    <el-option v-for="(item, index) in szList" :key="index" :value="item.Policy_ID"
                        :label="item.Policy_Name"></el-option>
                </el-select>
            </div>
            <el-input :rows="7" type="textarea" placeholder="请输入需要智能识别的内容" v-model="reviewText"></el-input>
            <span slot="footer">
                <el-button type="primary" @click="sendReviewData(true)">确认提交</el-button>
                <el-button @click="reviewSee = false">取消</el-button>
            </span>
        </el-dialog>

        <el-dialog title="批量导入" :visible.sync="excelImport" width="36%">
            <el-form>
                <el-form-item label="选择属组">
                    <el-select placeholder="请选择" v-model="multiSz">
                        <el-option v-for="(item, index) in szList" :key="index" :value="item.Policy_ID"
                            :label="item.Policy_Name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择excel文件">
                    <el-upload class="upload-demo" action="/Ajax/upload_json.ashx?dir=file" :multiple="false"
                        :show-file-list="false" :on-success="getExcelUrl" name="imgFile">
                        <el-button type="default" plain round>导入被保险人(excel)</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="已上传文件地址">
                    {{ excelUrl }}
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button type="primary" @click="sendImportData">确认导入</el-button>
                <el-button @click="excelImport = false">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

export default {
    data() {
        return {
            name: "",
            insuranceid: "",
            excelUrl: "",
            visitPersonArr: [
                {
                    InsurancePerson_Name: "",
                    InsurancePerson_CertNo: "",
                    InsurancePerson_Policy: "",
                    InsurancePerson_EmployerName: "",
                    InsurancePerson_EmployerAddress: "",
                    InsurancePerson_Relate: "",
                },
            ],
            total: 0,
            adVis: false,
            Policy_IsEvery: 0,
            Policy_Money: 0,
            outPersonArr: [
                {
                    InsurancePerson_Name: "",
                    InsurancePerson_CertNo: "",
                    InsurancePerson_Gender: "",
                    InsurancePerson_Birthday: "",
                },
            ],
            companyid: "",
            productsName: ["境内", "境外"],
            Policy_Delay: 0,
            personimage: "",
            totalperson: 0,
            personCount: 0,
            szID: "",
            guide: "",
            operator: "",
            starttime: "",
            day: "",
            TravelCompanyList: [],
            teamnumber: "",
            Policy_Name: "",
            policyid: "",
            policyItem: "",
            reviewSee: false,
            pass1: "",
            pass2: "",
            pass3: "",
            pass4: "",
            pass5: "",
            sendVal: true,
            quality: "",
            logotime: "",
            destination: "",
            delay: "",
            dilogVis: false,
            beforeSend: false,
            onceClick: false,
            excelImport: false,
            multiSz: "",
            tabName: "withTxt",
            orderTypeList: ['钟点单', '医护单', '白班家务', '白班育儿', '住家家务', '住家育儿', '月子单', '老人护理单'],
            ProductList: [],
            errArr: [],
            szList: [],
            reviewText: "",
            reviewType: "",
            userInfo: (JSON.parse(sessionStorage.getItem("userInfo")) || null),
        };
    },
    mounted() {
        this.getTravelCompanyList()

        this.starttime = new Date(Date.now() + 24 * 60 * 60 * 1000)
            .toLocaleDateString("zh-CN")
            .replace(/\//g, "-");
    },
    methods: {
        getExcelUrl(res) {
            if (res.result != "success") {
                this.$message.error(res.message);
                return
            }
            if (res.url == "" || res.url == null || res.url == undefined) {
                this.$message.error("上传失败");
                return
            }
            this.excelUrl = res.url

            // console.log(res.url)
        },
        addMultiPerson() {
            this.excelImport = true;
            this.multiSz = "";
        },
        setCompanyName() {
            this.getSzList()
            this.getPolicyList()
        },
        add0(num) {
            return num < 10 ? "0" + num : num;
        },
        reviewBD(type) {
            this.reviewType = type;
            this.reviewSee = true;
        },
        sendReviewData() {
            if (this.szID == "" || this.szID == null) {
                this.$message({ message: "请先选择属组", type: "warning" })
                return
            }
            if (this.reviewText == "" || this.reviewText == null) {
                this.$message({ message: "请先输入要识别的文本", type: "warning" })
                return
            }
            let url = "";
            if (this.reviewType == "withTxt") {
                url =
                    "/AdminTravel/InsuranceWelfarePerson.ashx?type=autorecognition";
            } else {
                url =
                    "/AdminTravel/InsuranceTravelPerson.ashx?type=autorecognitionpassport";
            }
            this.ipost(
                url,
                {
                    tmp: this.reviewText,
                    policyid: this.szID,
                },
                (res) => {
                    this.reviewSee = false;

                    if (res.list.length == 0) {
                        this.$message({
                            message: "未识别到有效信息",
                            type: "warning",
                        });
                        return;
                    }

                    if (this.reviewType == "withTxt") {
                        let tempArr = res.list.map((item) => {
                            return {
                                InsurancePerson_Name: item.InsurancePerson_Name,
                                InsurancePerson_CertNo: item.InsurancePerson_CertNo?.trim(),
                                InsurancePerson_Policy: item.InsurancePerson_Policy,
                                InsurancePerson_EmployerAddress: item.InsurancePerson_EmployerAddress,
                                InsurancePerson_EmployerName: item.InsurancePerson_EmployerName,
                                InsurancePerson_Relate: item.InsurancePerson_Relate,
                                check: false,
                            };
                        });
                        if (
                            this.visitPersonArr.length == 1 &&
                            this.visitPersonArr[0].InsurancePerson_Name == "" &&
                            this.visitPersonArr[0].InsurancePerson_CertNo == ""
                        ) {
                            this.visitPersonArr = tempArr;
                        } else {
                            this.visitPersonArr =
                                this.visitPersonArr.concat(tempArr);
                        }
                    } else {
                        let tempArr = res.list.map((item) => {
                            return {
                                InsurancePerson_Name: item.InsurancePerson_Name,
                                InsurancePerson_CertNo:
                                    item.InsurancePerson_CertNo?.trim(),
                                InsurancePerson_Policy: item.InsurancePerson_Policy,
                                check: false,
                            };
                        });
                        if (
                            this.outPersonArr.length == 1 &&
                            this.outPersonArr[0].InsurancePerson_Name == "" &&
                            this.outPersonArr[0].InsurancePerson_CertNo == "" &&
                            this.outPersonArr[0].InsurancePerson_Policy == ""
                        ) {
                            this.outPersonArr = tempArr;
                        } else {
                            this.outPersonArr =
                                this.outPersonArr.concat(tempArr);
                        }
                    }


                }
            );
        },
        checkboxChange(val, indx) {
            let arrName =
                this.tabName == "withTxt" ? "visitPersonArr" : "outPersonArr";
            if (val) {
                this[arrName][indx].check = true;
            } else {
                this[arrName][indx].check = false;
            }
        },
        deleteCheck() {
            this.$confirm(
                "此操作将删除选中的人员，是否继续?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    let tempArr = [];
                    if (this.tabName == "withTxt") {
                        tempArr = this.visitPersonArr.filter((item) => {
                            if (item.check == false || item.check == undefined)
                                return true;
                        });

                        this.visitPersonArr = [];
                        this.visitPersonArr = tempArr;
                        // console.log(this.visitPersonArr);
                    } else {
                        tempArr = this.outPersonArr = this.outPersonArr.filter(
                            (item) => {
                                if (item.check == false || item.check == undefined)
                                    return true;
                            }
                        );

                        this.outPersonArr = [];
                        this.outPersonArr = tempArr;
                        // console.log(this.outPersonArr);
                    }
                })
        },
        deleteAll() {
            this.$confirm(
                "此操作将删除所有的人员，是否继续?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            ).then(() => {
                if (this.tabName == "withTxt") {
                    this.visitPersonArr = [];
                } else {
                    this.outPersonArr = [];
                }
                this.$message({
                    type: "success",
                    message: "删除成功!",
                });
            })

        },
        getSzList() {
            if (this.companyid == "") {
                this.$message({
                    type: "warning",
                    message: "请先选择企业!",
                });
                return
            }
            this.ipost(
                "/AdminTravel/PolicyWelfare.ashx?type=select",
                {
                    pageindex: 1,
                    pagesize: 666,
                    companyid: this.companyid
                },
                (res) => {
                    this.szList = res.list;
                }
            );
        },
        nameSearch(qs, cb) {
            let tempArr = this.JDNames.map((item) => {
                return {
                    name: item.Insurance_Operator,
                    value: item.Insurance_Operator,
                };
            });
            cb(tempArr);
        },
        querySearch(qs, cb) {
            cb([
                { name: "男", value: "男" },
                { name: "女", value: "女" },
            ]);
        },
        switchTab(e) {
            // console.log("switch tab name:", e.name);
            this.tabName = e.name;
        },
        insuraceModel(n) {
            let temp = "/AdminTravel/travelperson.xlsx";
            if (n == 1) {
                temp = "/AdminTravel/travelpersonpassport.xlsx";
            }
            window.open(temp, "_blank");
        },
        setImgUrl(res) {
            this.personimage = res.url;
            // console.log("personimage", this.personimage);
        },
        sendImportData() {
            if (this.excelUrl == "") {
                this.$message({
                    type: "error",
                    message: "请先上传文件！",
                });
                return
            }
            if (this.multiSz == "" || this.multiSz == undefined) {
                this.$message({
                    type: "error",
                    message: "请先选择属组！",
                });
                return
            }
            this.ipost(
                "/AdminTravel/InsuranceWelfarePerson.ashx?type=import",
                {
                    url: this.excelUrl,
                    policyid: this.multiSz
                },
                (res) => {
                    if (this.tabName == "withTxt") {
                        let tempArr = res.list.map((item) => {
                            return {
                                InsurancePerson_Name:
                                    item.InsurancePerson_Name,
                                InsurancePerson_CertNo:
                                    item.InsurancePerson_CertNo.trim(),
                                InsurancePerson_Policy: item.InsurancePerson_Policy,
                                InsurancePerson_EmployerName: item.InsurancePerson_EmployerName,
                                InsurancePerson_EmployerAddress: item.InsurancePerson_EmployerAddress,
                                InsurancePerson_Relate: item.InsurancePerson_Relate,
                                check: false,
                            };
                        });
                        if (
                            this.visitPersonArr.length == 1 &&
                            this.visitPersonArr[0].InsurancePerson_Name ==
                            "" &&
                            this.visitPersonArr[0].InsurancePerson_CertNo ==
                            ""
                        ) {
                            this.visitPersonArr = tempArr;
                        } else {
                            this.visitPersonArr =
                                this.visitPersonArr.concat(tempArr);
                        }
                    } else {
                        let tempArr = res.list.map((item) => {
                            return {
                                InsurancePerson_Name:
                                    item.InsurancePerson_Name,
                                InsurancePerson_CertNo:
                                    item.InsurancePerson_CertNo.trim(),
                                InsurancePerson_Policy: item.InsurancePerson_Policy,
                                check: false,
                            };
                        });
                        if (
                            this.outPersonArr.length == 1 &&
                            this.outPersonArr[0].InsurancePerson_Name ==
                            "" &&
                            this.outPersonArr[0].InsurancePerson_CertNo ==
                            "" &&
                            this.outPersonArr[0].InsurancePerson_Gender ==
                            "" &&
                            this.outPersonArr[0].InsurancePerson_Birthday ==
                            ""
                        ) {
                            this.outPersonArr = tempArr;
                        } else {
                            this.outPersonArr =
                                this.outPersonArr.concat(tempArr);
                        }
                    }

                    this.excelImport = false;
                }
            );

        },
        sendFormData() {
            if (this.insuranceid == "") {
                this.$message({
                    type: "error",
                    message: "请先选择合同！",
                });
                return
            }
            // console.log("sendFormData", this.checkFormData());
            let tempUrl =
                "/AdminTravel/InsuranceWelfare.ashx?type=insertparambyagencyadminadd";
            let postData = {
                starttime: this.starttime,
                companyid:this.companyid,
                insuranceid: this.insuranceid
            };
            if (this.checkFormData() == true) {
                if (this.tabName == "withTxt") {
                    postData.personlist = JSON.stringify(this.visitPersonArr);
                } else if (this.tabName == "withPass") {
                    postData.personlist = JSON.stringify(this.outPersonArr);
                }

            } else {
                return;
            }
            this.ipost(
                tempUrl,
                postData,
                (res) => {
                    this.resetForm();
                    this.$message({
                        message: "添加成功",
                        type: "success",
                    });

                }
            )
        },

        resetForm() {
            this.visitPersonArr.length = 1;
            this.outPersonArr.length = 1;
            this.visitPersonArr[0]["InsurancePerson_Name"] = "";
            this.visitPersonArr[0]["InsurancePerson_CertNo"] = "";
            this.visitPersonArr[0]["InsurancePerson_Policy"] = "";
            this.visitPersonArr[0]["InsurancePerson_EmployerName"] = "";
            this.visitPersonArr[0]["InsurancePerson_EmployerAddress"] = "";
            this.visitPersonArr[0]["InsurancePerson_Relate"] = "";
            this.visitPersonArr[0]["check"] = false;
            this.outPersonArr[0]["InsurancePerson_Name"] = "";
            this.outPersonArr[0]["InsurancePerson_CertNo"] = "";
            this.outPersonArr[0]["InsurancePerson_Policy"] = "";
            this.outPersonArr[0]["check"] = false;
            this.personlist = "";
            this.starttime = "";
            this.day = "";
            this.insuranceid = "";
        },
        getTravelCompanyList() {
            this.ipost(
                "/AdminTravel/TravelCompany.ashx?type=select", {
                pageindex: 1,
                pagesize: 999,
            },
                (res) => {
                    console.log("res:", res)
                    this.TravelCompanyList = res.list
                    this.total = res.count
                }
            );
        },
        getPolicyList() {
            if (this.companyid == "") {
                this.$message({
                    type: "warning",
                    message: "请先选择企业!",
                });
                return
            }
            this.ProductList.length = 0;
            this.policyItem = "";
            this.policyid = "";
            this.ipost(
                "/AdminTravel/InsuranceWelfare.ashx?type=select",
                {
                    pageindex: 1,
                    pagesize: 666,
                    companyid: this.companyid,
                },
                (res) => {
                    this.ProductList = res.list;
                    this.Policy_Name = this.policyItem =
                        res.list[0].Policy_Name || "";
                    this.policyid = res.list[0].Policy_ID || "";
                    // this.total = res.count
                    // console.log("合同列表 res:", res);

                }
            );
        },
        review() {
            if (this.checkFormData()) {
                this.dilogVis = true;
            }
        },
        addPerson() {
            this.visitPersonArr.push({
                InsurancePerson_Name: "",
                InsurancePerson_CertNo: "",
                InsurancePerson_EmployerAddress: "",
                InsurancePerson_EmployerName: "",
                check: false,
            });
        },
        confirmPerson() {
            this.errArr = [];

            for (let i = 0; i < this.visitPersonArr.length; i++) {
                let current = this.visitPersonArr[i];

                if (
                    current.InsurancePerson_Name == "" ||
                    current.InsurancePerson_CertNo == "" ||
                    current.InsurancePerson_CertNo.trim().length != 18
                ) {
                    this.errArr.push(current.InsurancePerson_CertNo);
                }
            }

            if (this.errArr.length > 0) {
                this.$message("个别人员信息有误，请检查");

                let firstIndx = this.visitPersonArr.findIndex(
                    (item) => item.InsurancePerson_CertNo == this.errArr[0]
                );

                let aimHeight = 56 + 83 * (firstIndx + 1);

                // console.log("aimHeight", aimHeight);
                document
                    .querySelector(".person-list-wrp")
                    .scrollTo(0, aimHeight);

                return false;
            }

            this.ipost(
                "/AdminTravel/InsuranceTravel.ashx?type=checkpersonlist",
                {
                    personlist: JSON.stringify(this.visitPersonArr),
                },
                (res) => {
                    this.$message("校验全部通过...");
                },
                (res) => {
                    this.errArr = res.list.map(
                        (item) => item.InsurancePerson_CertNo
                    );
                    // console.log("errArr", this.errArr);

                    let firstIndx = this.visitPersonArr.findIndex(
                        (item) => item.InsurancePerson_CertNo == this.errArr[0]
                    );

                    let aimHeight = 56 + 83 * (firstIndx + 1);

                    // console.log("aimHeight", aimHeight);
                    document
                        .querySelector(".person-list-wrp")
                        .scrollTo(0, aimHeight);
                }
            );
        },
        addOPerson() {
            this.outPersonArr.push({
                InsurancePerson_Name: "",
                InsurancePerson_CertNo: "",
                InsurancePerson_Policy: "",
                InsurancePerson_EmployerName: "",
                InsurancePerson_EmployerAddress: "",
                InsurancePerson_Relate: "",
                check: false,
            });
        },
        sendDelete(index, n) {
            if (n == 1) {
                this.outPersonArr.splice(index, 1);
            } else {
                let errIndx = this.errArr.findIndex(
                    (item) =>
                        item ==
                        this.visitPersonArr[index].InsurancePerson_CertNo
                );
                if (errIndx != -1) {
                    this.errArr.splice(errIndx, 1);
                }
                this.visitPersonArr.splice(index, 1);
            }
        },
        checkFormData() {
            // if (this.starttime == "") {
            //     this.$message("请填写保险开始时间");
            //     return false;
            // }


            if (this.tabName == "withTxt") {
                for (let i = 0; i < this.visitPersonArr.length; i++) {
                    let current = this.visitPersonArr[i];

                    if (current.InsurancePerson_Name == "") {
                        this.$message(`被保险人${i + 1}的名字不能为空`);
                        return false;
                    }

                    if (current.InsurancePerson_CertNo == "") {
                        this.$message(`被保险人${i + 1}的身份证号不能为空`);
                        return false;
                    }

                    // if (current.InsurancePerson_EmployerAddress == "") {
                    //     this.$message(`被保险人${i + 1}的雇主家庭地址不能为空`);
                    //     return false;
                    // }

                    // if (current.InsurancePerson_EmployerName == "") {
                    //     this.$message(`被保险人${i + 1}的雇主姓名不能为空`);
                    //     return false;
                    // }

                    // console.log("current.InsurancePerson_Policy", current.InsurancePerson_Policy)
                    if (current.InsurancePerson_Policy == "" || current.InsurancePerson_Policy == undefined) {
                        this.$message(`被保险人${i + 1}的属组不能为空`);
                        return false;
                    }

                    // if (current.InsurancePerson_Relate == "" || current.InsurancePerson_Relate == undefined) {
                    //     this.$message(`被保险人${i + 1}的订单类型不能为空`);
                    //     return false;
                    // }

                    if (
                        /^(([\u2E80-\uFE4F](?![\u3000-\u303F])))+(·)?( )*(([\u2E80-\uFE4F](?![\u3000-\u303F])))+$/.test(
                            current.InsurancePerson_Name.trim()
                        ) == false
                    ) {
                        this.$message(`请正确填写被保险人${i + 1}的中文名字`);
                        return false;
                    }
                    if (current.InsurancePerson_CertNo.length !== 18) {
                        this.$message(`请正确填写被保险人${i + 1}的身份证信息`)
                        return false
                    }
                }
            }

            if (this.tabName == "withPass") {
                for (let i = 0; i < this.outPersonArr.length; i++) {
                    let current = this.outPersonArr[i];
                    if (
                        current.InsurancePerson_Name == "" ||
                        current.InsurancePerson_CertNo == "" ||
                        current.InsurancePerson_Policy == ""
                    ) {
                        this.$message(`请正确填写被保险人${i + 1}的信息`);
                        return false;
                    }
                }
            }

            return true;
        },
    },
};
</script>

<style scoped>
.cls-btn {
    position: absolute;
    top: -22px;
    right: 0;
    display: block;
    height: 22px;
    width: 37px;
    z-index: 1;
    opacity: 1;
    font-size: 13px;
    cursor: pointer;
}

.person-list-wrp .el-select {
    width: 100%;
}

.check-box-wrp {
    display: flex;
    justify-content: center;
    align-items: center;
}

.check-box-wrp .el-checkbox {
    margin-top: 40px;
}

.form-input-wrp {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.form-input-wrp .el-input {
    width: calc(100% - 120px);
}

.dateSelect {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.dateSelect p {
    color: #999;
    font-size: 14px;
    text-decoration: 0 0 2px #ccc;
    line-height: 37px;
    padding: 0 6px;
    margin: 0;
}

.insurance-btn-wrp {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.insurance-btn-wrp .el-button {
    margin-right: 7px;
}

.lbt {
    text-align: center;
    font-size: 13px;
}

.page-cont {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position: relative;
}

.page-ad {
    position: absolute;
    bottom: 0;
    left: 50%;
    font-size: 0;
    transform: translateX(-50%);
    background-image: url("../assets/xct.jpg");
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: auto 100%;
    box-shadow: 0 0 6px #999;
}

.page-ad img {
    opacity: 0;
    height: 16vh;
    max-height: 180px;
    min-height: 60px;
}

.form-ipt .el-col {
    display: flex;
    margin-bottom: 12px;
}

.form-ipt .el-col label {
    width: 77px;
    font-size: 14px;
}

.infoCheck {
    width: 97%;
    padding: 15px;
    box-sizing: border-box;
    margin: 10px auto;
    border-radius: 6px;
    box-shadow: 0 0 12px #dedede;
    background-color: #fefefe;
}

.person-info {
    position: relative;
    height: auto;
    display: flex;
    flex-direction: column;
    height: 100%;
    /* height: calc(100% - 210px); */
}

.person-list-wrp {
    max-height: calc(100vh - 305px);
    overflow: hidden;
    overflow-y: auto;
}

.infoCheck h2 {
    margin: 6px 0;
}

.top-btns {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.top-btns .el-button {
    margin-left: 8px;
}

.infoCheck label {
    line-height: 2.7;
}

.destwrp {
    line-height: 40px;
    text-align: center;
}

.btnswrp {
    margin: 5px auto;
    text-align: right;
}

.top-row {
    margin: 5px 0;
}

.top-row h2 {
    margin: 0;
}

.btn-delt .el-button {
    margin-top: 40px;
}

.ylwrp {
    font-size: 16px;
    font-weight: bold;
}

.ylwrp label {
    line-height: 37px;
    margin-right: 12px;
    font-size: 13px;
    color: #a1a1a1;
}

.vis-person {
    margin-top: 17px;
    border-top: 1px dashed #ccc;
}

.err .el-input,
.err .el-input .el-input__inner {
    border: 1px solid #f00 !important;
    background-color: #f00 !important;
    border-radius: 4px;
}

em {
    font-style: normal;
    color: tomato;
}
</style>
